module.exports = __webpack_public_path__ + "img/q1.4b6bb9d0.png";